import { connectedStore } from '../../store';
import getSite from '../selectors/site';

const isMultilingualSite = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const site = getSite(state);
  return Boolean(site.meta.multilingual);
};

export default isMultilingualSite;
